import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const sortAdminConversationForm = async ({ id, type }: { id: number; type: string }) => {
    const urlName = type === 'down' ? `adminCommunicationItemDown` : 'adminCommunicationItemUp';

    // @ts-ignore
    const url = helpable.replaceUrlParameters(
        // @ts-ignore
        routable.getRoute(urlName),
        {
            _id_: id,
        }
    );

    try {
        // @ts-ignore
        loader.show();
        const response = await $api.post(url);
        // @ts-ignore
        loader.hide();
        return response.data;
    } catch (error) {
        // @ts-ignore
        loader.hide();
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
